import {Directive, ElementRef, EventEmitter, Output, OnDestroy} from '@angular/core';
import ResizeObserver from 'resize-observer-polyfill'; //not needed really since > Chrome 64

const entriesMap = new WeakMap();

const ro = new ResizeObserver(
	(entries: ResizeObserverEntry[], observer: ResizeObserver): void => {
		for (const entry of entries) {
			if (entriesMap.has(entry.target)) {
				const comp = entriesMap.get(entry.target);
				comp._resizeCallback(entry);
			}
		}
	}
);

/**
 * @deprecated `resizeObserver (resizeObserver)="..."` has been deprecated. Please use `(onElementResized)="..."`.
 */
@Directive({
    selector: '[resizeObserver]',
    standalone: false
})
export class ResizeObserverDirective implements OnDestroy {
	@Output()
	resize = new EventEmitter();

	constructor(private el: ElementRef) {
		const target = this.el.nativeElement;
		entriesMap.set(target, this);
		ro.observe(target);
	}

	_resizeCallback(entry) {
		this.resize.emit(entry);
	}

	ngOnDestroy() {
		const target = this.el.nativeElement;
		ro.unobserve(target);
		entriesMap.delete(target);
	}
}
